/**
 * Tiny in-memory search aggregator for the hub. Each source is a function
 * that returns rows of `{ kind, id, title, subtitle, route, icon }` ·
 * the palette iterates all sources, scores against the query, groups by
 * kind, and renders. Adding a new searchable surface = one entry in
 * SOURCES below; nothing else changes.
 *
 * Matching is a permissive case-insensitive substring on title + subtitle
 * (no fuzzy lib · current dataset is small enough that exact substring
 * is plenty). Could swap for fuse.js later without changing call sites.
 */

const ACCENT_FOLD = (s) => (s || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase();

export function scoreRow(row, q) {
  if (!q) return 0;
  const haystack = ACCENT_FOLD(`${row.title} ${row.subtitle || ''}`);
  const needle = ACCENT_FOLD(q);
  const idx = haystack.indexOf(needle);
  if (idx === -1) return -1;
  // Earlier match + title-only > subtitle scores higher.
  const titleHit = ACCENT_FOLD(row.title).includes(needle);
  return (titleHit ? 1000 : 0) - idx;
}

export function searchAll(query, sources) {
  const q = (query || '').trim();
  if (!q) return [];
  const out = [];
  for (const src of sources) {
    const rows = src() || [];
    for (const row of rows) {
      const s = scoreRow(row, q);
      if (s >= 0) out.push({ ...row, _score: s });
    }
  }
  out.sort((a, b) => b._score - a._score);
  return out;
}

export function groupByKind(results) {
  const map = new Map();
  for (const r of results) {
    if (!map.has(r.kind)) map.set(r.kind, []);
    map.get(r.kind).push(r);
  }
  return map;
}
